export default __webpack_public_path__ + "static/media/VectorXblack.3f121969.svg";